import { searchSetting } from '../constants';

export function getDate(sdate, edate) {
  return {
    type: searchSetting.GET_DATE,
    sDate: sdate.substr(0,4) + sdate.substr(5,2) + sdate.substr(8,2) + sdate.substr(10,6) + ':00',
    eDate: edate.substr(0,4) + edate.substr(5,2) + edate.substr(8,2) + edate.substr(10,6) + ':00',
    sDateHyphen: sdate,
    eDateHyphen: edate,
    // receivedAt: Date.now()
  }
}

export function setStatus(status){
  return{
    type:searchSetting.SET_TIME_STATUS,
    status:status,
  }
}



// WEBPACK FOOTER //
// ./src/actions/timeSelect.actions.js